/* Draft-only resource access. Never change customer identity or membership ownership. */
(() => {
  if (window.Shopify?.theme?.id !== 166846169308) return;

  const resourcePaths = new Set([
    '/pages/provider-hub',
    '/pages/resource-library',
    '/pages/complete-resource-index',
    '/pages/getting-started',
    '/pages/updates-versions',
    '/pages/energy-aware-planning',
    '/pages/brain-fog-executive-function',
    '/pages/patient-facing-everyday-support',
  ]);
  const resourceViews = new Set([
    'providers', 'provider-energy-planning', 'energy-activity-mgmt',
    'brain-fog-exec-function', 'brain-fog-exec-function-2',
    'patient-everyday-support', 'daily-life-support', 'resource-library',
    'complete-resource-index', 'getting-started', 'updates-versions',
  ]);
  const pathname = window.location.pathname.replace(/\/$/, '');
  if (!resourcePaths.has(pathname)) return;

  // Both the requested view and the rendered template must be resource-only.
  const views = new URLSearchParams(window.location.search).getAll('view');
  if (views.some((view) => !resourceViews.has(view))) return;
  const template = document.querySelector('#MainContent')?.dataset.template;
  if (template !== 'page' && !resourceViews.has(template?.replace(/^page\./, ''))) return;

  const config = window.AM?.Config;
  // Appstle merges its customer-specific Liquid config immediately before restriction.
  const customerConfig = window._AMConfig;
  const tags = customerConfig?.customer_tags ?? config?.customer_tags;
  if (!config || !Array.isArray(tags) || customerConfig?.rulesByCustomerTag !== undefined) return;
  const customerTags = tags.map((tag) => tag.toLowerCase());
  const secondaryTags = ['aa-pro-practice', 'aa-pro-expanded'];
  if (!secondaryTags.some((tag) => customerTags.includes(tag))) return;

  try {
    const rulesByTag = JSON.parse(config.rulesByCustomerTag);
    const soloRules = JSON.parse(rulesByTag['aa-pro-solo']?.[0]);
    if (!Array.isArray(soloRules)) return;

    const resourceRules = soloRules.filter((rule) =>
      rule.rule === 'element' && rule.selector === 'main' &&
      rule.limitAccessType === 'page' && rule.elementRestrictType === 'url' &&
      typeof rule.path === 'string'
    ).map((rule) => {
      // Copy only page restriction fields, never discounts or purchaser perks.
      const paths = rule.path.split(',').map((path) => path.trim())
        .filter((path) => resourcePaths.has(path));
      return {
        rule: 'element', selector: 'main', message: rule.message,
        limitAccessType: 'page', elementRestrictType: 'url',
        path: paths.flatMap((path) => [path, `${path}/`]).join(', '),
        pathMatch: 'exact',
        ...(rule.allowDuringDunning !== undefined ? { allowDuringDunning: rule.allowDuringDunning } : {}),
      };
    }).filter((rule) => rule.path && rule.path.split(', ').includes(window.location.pathname));
    if (!resourceRules.length) return;

    let changed = false;
    for (const tag of secondaryTags) {
      if (customerTags.includes(tag) && !Object.prototype.hasOwnProperty.call(rulesByTag, tag)) {
        rulesByTag[tag] = [JSON.stringify(resourceRules)];
        changed = true;
      }
    }
    // In-memory only: no customer tags, plan mappings, portal settings or storage writes.
    if (changed) config.rulesByCustomerTag = JSON.stringify(rulesByTag);
  } catch {
    // Missing or unexpected Appstle configuration leaves its existing rules intact.
  }
})();
